import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthGuard } from '../../../core/services/auth/auth-guard.service';
import { UsuarioPerfil, usuarioPerfilAdministrador, usuarioPerfilGerente, usuarioPerfilRepresentante, usuarioPerfilAtendente } from '../../usuario/usuario-perfil';


/** Acessos permitidos a consulta das cotações perdidas por itens */
export const acessosCotacaoPerdidaItem: UsuarioPerfil[] = [usuarioPerfilAdministrador, usuarioPerfilGerente, usuarioPerfilRepresentante, usuarioPerfilAtendente];

@Injectable()
export class CanActivateCotacaoPerdidaItem implements CanActivateChild {

    constructor(private authGuard: AuthGuard) { }

    canActivateChild(): boolean {
        return this.authGuard.canActivateAcesso(acessosCotacaoPerdidaItem);
    }
}
